import SuperFetch from 'library/helpers/superFetch';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { defaultCategoriesActions } from './slice';

// Sagas
export function* getDefaultCategories() {
	try {
		// Get the orgID from the selected profile
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		// Get categories from the current organisation.
		const defaultCategories = yield call(() =>
			SuperFetch.get('/deviceCategories/defaultCategories', {}, { includeFields: true })
		);
		if (defaultCategories.statusCode === 200) {
			yield put(defaultCategoriesActions.loadDefaultCategoriesSuccess({ orgID, data: defaultCategories.data }));
		} else {
			throw Error(defaultCategories.error.message || 'Failed to load categories.');
		}
	} catch (error) {
		yield put(defaultCategoriesActions.loadCategoriesError(error));
	}
}

export function* getAllDefaultCategoryFields() {
	try {
		// Get all default category fields
		const defaultCategoryFields = yield call(() =>
			SuperFetch.get('/deviceCategories/defaultCategories/getAllDefaultCategoryFields')
		);

		if (defaultCategoryFields.statusCode === 200) {
			yield put(defaultCategoriesActions.loadDefaultCategoryFieldsSuccess({ data: defaultCategoryFields.data }));
		} else {
			throw Error(defaultCategoryFields.error.message || 'Failed to load category fields.');
		}
	} catch (error) {
		yield put(defaultCategoriesActions.loadDefaultCategoryFieldsError(error));
	}
}

export default function* categoriesSaga() {
	yield takeLatest(defaultCategoriesActions.loadDefaultCategories, getDefaultCategories);
	yield takeLatest(defaultCategoriesActions.loadAllDefaultCategoryFields, getAllDefaultCategoryFields);
}
